import createSite from './create-site';
import setTemplatesData from './set-templates-data';
import setSingleTemplate from './set-single-template';

export default {
  createSite,
  setTemplatesData,
  setSingleTemplate,
};
